module.exports = __webpack_public_path__ + "img/dynamic-14.908bf91b.png";